import React, { Component } from 'react'
import withStyles from 'constructicon/with-styles'
import styles from './styles'

import Icon from 'constructicon/icon'
import ReactSlider from 'react-slider'

class Slider extends Component {
  constructor (props) {
    super(props)
    this.handleChange = this.handleChange.bind(this)
    this.state = {
      zoom: props.value
    }
  }

  valueInRange (value, min, max) {
    return Math.min(max, Math.max(value, min))
  }

  operators (direction) {
    switch (direction) {
      case '-':
        return (a, b) => a - b
      default:
        return (a, b) => a + b
    }
  }

  handleChange (direction) {
    const { max, min, onChange, step } = this.props

    const zoom = this.valueInRange(
      this.operators(direction)(this.state.zoom, step * 5),
      min,
      max
    )

    return this.setState({ zoom }, () => onChange(zoom))
  }

  render () {
    const { zoom } = this.state
    const { classNames, onChange, min, max, step } = this.props

    return (
      <div className={classNames.root}>
        <button
          disabled={zoom === min}
          className={classNames.control}
          onClick={() => this.handleChange('-')}
        >
          <Icon name='minus' size={0.75} />
        </button>
        <ReactSlider
          className={classNames.slider}
          handleClassName={classNames.sliderHandle}
          value={zoom}
          min={min}
          max={max}
          step={step}
          onChange={zoom => this.setState({ zoom }, () => onChange(zoom))}
        />
        <button
          disabled={zoom === max}
          className={classNames.control}
          onClick={() => this.handleChange('+')}
        >
          <Icon name='plus' size={0.75} />
        </button>
      </div>
    )
  }
}

Slider.defaultProps = {
  max: 200,
  min: 100,
  step: 1,
  value: 100
}

export default withStyles(styles)(Slider)
